import { gql } from '@apollo/client';

export const GET_CHECKHOMEWORK_LIST = gql`
  query SkWeb_CheckHomeworkList(
    $username: String
    $schoolId: ID
    $productId: ID
    $classroomId: ID
    $titleId: ID
    $booksetIds: [ID]
    $page: Int
    $pageSize: Int
  ) {
    checkHomeworkList(
      username: $username
      schoolId: $schoolId
      productId: $productId
      classroomId: $classroomId
      titleId: $titleId
      booksetIds: $booksetIds
      page: $page
      pageSize: $pageSize
    ) {
      data {
        id
        userId
        name
        username
        classroom {
          id
          name
        }
        undoneHomeWork(titleId: $titleId, booksetIds: $booksetIds)
        expiredWithoutMakingUpHomeworks(titleId: $titleId, booksetIds: $booksetIds)
        __typename
      }
      totalCount
    }
  }
`;
